<div class="container-fluid vh-auto">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="course-heading text-start">Course Objective</h3>
  </div>
  <p class="sub-head text-start">
    what will students learn from this course? Add specific learning objectives.
  </p>

  <div class="modal-form">
    <form [formGroup]="createCourseForm">
      <div class="mb-4">
        <textarea formControlName="course_objectives" class="form-control"
		 placeholder="summarize the learning objectives in clear points..." rows="10"></textarea>
    </div>

     
    </form>
  </div>

  <div class="d-flex justify-content-between align-items-center">
    <button type="button" class="btn-cancel py-2 mt-2" (click)="goToPrePage()">
      <mat-icon class="icon-middle me-2">chevron_left</mat-icon> Previous
    </button>

    <button type="submit" class="btn-add mb-2" (click)="goToNextPage()" [disabled]="createCourseForm.invalid">
      Next <mat-icon class="icon-middle">chevron_right</mat-icon>
    </button>
  </div>
</div>
